import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL } from '@sorare/core/src/atoms/typography';
import { Video } from '@sorare/core/src/atoms/ui/Video';
import { useConnectionContext } from '@sorare/core/src/contexts/connection';

import av1 from './assets/stage.av1.webm';
import h264 from './assets/stage.h264.mp4';
import vp9 from './assets/stage.vp9.webm';

const Root = styled.section`
  width: 100%;
  min-height: 60vh;
  display: grid;
  align-items: center;
  justify-items: center;
  isolation: isolate;
  position: relative;
  &::before {
    position: absolute;
    inset: 0;
    z-index: 1;
    content: '';
    background: linear-gradient(180deg, rgba(16, 16, 16, 0) 75%, #101010 100%),
      radial-gradient(
        50% 50% at 50% 50%,
        rgba(0, 0, 0, 0.6) 0%,
        rgba(0, 0, 0, 0) 100%
      ),
      linear-gradient(180deg, #101010 0%, rgba(16, 16, 16, 0) 17%);
  }
  > * {
    grid-row-start: 1;
    grid-column-start: 1;
  }
`;
const Header = styled(Vertical)`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: var(--quadruple-unit);
  text-align: center;
  width: 100%;
`;
const Title = styled.h1`
  font-size: var(--fs-landing-title);
`;

export const HeroVideo = () => {
  const { signUp } = useConnectionContext();
  return (
    <Root>
      <Video
        sources={[
          { src: av1, type: 'video/webm; codecs="av01.0.31M.08,opus"' },
          { src: vp9, type: 'video/webm; codecs="vp9"' },
          { src: h264 },
        ]}
        autoPlay
        loop
        muted
      />
      <Header center>
        <div>
          <Title>
            <FormattedMessage
              id="landing.EarlyAccess.title"
              defaultMessage="The Future of Fantasy Football"
            />
          </Title>
          <BodyL>
            <FormattedMessage
              id="landing.EarlyAccess.description"
              defaultMessage="Be ahead of the game for the 2024-25 season.{br} Create your club now and compete for more than $15,000,000 in total cash prizes."
              values={{ br: <br /> }}
            />
          </BodyL>
        </div>
        <Horizontal>
          <Button color="secondary" size="medium" onClick={signUp}>
            <FormattedMessage
              id="landing.EarlyAccess.HeroVideo.cta1"
              defaultMessage="Play now"
            />
          </Button>
          <Button
            color="tertiary"
            size="medium"
            to="/blog/sorare-season-2024-25-updates"
          >
            <FormattedMessage
              id="landing.EarlyAccess.HeroVideo.cta2"
              defaultMessage="Read the update"
            />
          </Button>
        </Horizontal>
      </Header>
    </Root>
  );
};
